module.exports = videojs;


//////////////////
// WEBPACK FOOTER
// external "videojs"
// module id = H527
// module chunks = 3